import { helpers } from '@vuelidate/validators'
import { DateTime } from 'luxon'

export const minDateValidator = (min?: Date | null) => {
  return helpers.withMessage(
    ({ $params }) =>
      `La fecha mínima permitida es ${DateTime.fromJSDate($params.min ?? new Date()).toISODate()}`,
    helpers.withParams({ min }, (val: Date) => {
      const _val = DateTime.fromJSDate(val).toISODate()
      const _min = DateTime.fromJSDate(min ?? new Date()).toISODate()
      if (!helpers.req(val) || !_val || !_min) return true
      return (
        Math.floor(
          DateTime.fromISO(_val).diff(DateTime.fromISO(_min), 'days').toObject().days ?? 0
        ) >= 0
      )
    })
  )
}
